import React, { useEffect } from "react";
import Minorcon from "./Minorcon";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Minor() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Minorcon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Minor OT in Whitefield | Minor OT in Vijayanagar</title>
        <meta
          name="description"
          content="Looking for the best minor ot in Whitefield? Then you are in the right place. Feel free to contact us today."
        />
        <meta
          name="keywords"
          content="Best Minor OT Service in Whitefield, Best Minor OT Service in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestminorotservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestminorotservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics provides Minor OT (Operating Theatre) services in Whitefield, Bangalore for safe outpatient procedures such as wound care & suturing, biopsies, dermatology procedures, and more—supported by expert medical supervision and a sterile setup.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            telephone: ["+91-9535264855", "+91-9535264854"],
            email: "elvhealthcare@gmail.com",
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            keywords: [
              "Best Minor OT Services in Immadihalli",
              "Best Minor OT Services in Whitefield",
              "Best Minor OT Services in Bangalore",
              "Best Minor OT Services in Kundalahalli",
              "Best Minor OT Services in Pattandur Agrahara",
            ],
            knowsAbout: [
              "Minor OT (Operating Theatre) services",
              "Wound care, suturing, and dressing changes",
              "Skin biopsies, mole/cyst excisions, wart removal",
              "Abscess drainage and wound debridement",
              "Joint injections and minor orthopedic procedures",
              "Gynecology minor procedures (biopsy, IUD insertion/removal)",
              "ENT minor procedures (foreign body removal, nasal cauterization)",
              "Home minor OT support and pathology sample collection",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Minor OT in Whitefield quality and compassionate care. Contact us today
        for the best minor OT in Whitefield.
      </h2>
      <Servicebanner name="Minor OT" banner={"../photo/dd13.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Minor;
